import { useState } from "react";

export default function ScoreGauge({ score }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const color = score >= 70 ? "#00C896" : score >= 40 ? "#FFB830" : "#FF4D6D";
  const circumference = 2 * Math.PI * 38;
  const dash = (score / 100) * circumference;

  const explanation =
    score >= 85 ? "Excellent — all ratios clearly pass with high confidence data" :
    score >= 70 ? "Good — all ratios pass, data quality is reliable" :
    score >= 50 ? "Borderline — some ratios are close to thresholds" :
    score >= 30 ? "Weak — one or more ratios fail or data is incomplete" :
    "Poor — business activity or multiple ratios fail";

  return (
    <div style={{ position:"relative", display:"inline-block" }}>
      <div
        style={{ position:"relative", width:100, height:100, cursor:"pointer" }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(v => !v)}
      >
        <svg width="100" height="100" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="38" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="7"/>
          <circle
            cx="50" cy="50" r="38" fill="none"
            stroke={color} strokeWidth="7" strokeLinecap="round"
            strokeDasharray={`${dash} ${circumference}`}
            transform="rotate(-90 50 50)"
            style={{ transition:"stroke-dasharray 0.8s cubic-bezier(0.16,1,0.3,1)" }}
          />
        </svg>
        <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
          <span style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:24, color }}>{score}</span>
          <span style={{ fontSize:9, color:"#4A5568", letterSpacing:"0.1em", textTransform:"uppercase" }}>score</span>
        </div>
        {/* Info icon */}
        <div style={{ position:"absolute", top:2, right:2, width:16, height:16, borderRadius:"50%", background:"rgba(255,255,255,0.08)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:9, color:"#4B5563", fontWeight:700 }}>?</div>
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div style={{
          position:"absolute", right:0, top:110, zIndex:200,
          background:"#0F172A", border:"1px solid rgba(255,255,255,0.12)",
          borderRadius:12, padding:"14px 16px", width:220,
          boxShadow:"0 16px 40px rgba(0,0,0,0.6)",
        }}>
          <div style={{ fontSize:11, fontWeight:700, color:"#E8EAF0", marginBottom:8 }}>Shariah Score — {score}/100</div>
          <div style={{ fontSize:11, color:"#9CA3AF", lineHeight:1.7, marginBottom:10 }}>{explanation}</div>
          <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
            {[
              { range:"85-100", label:"Excellent", color:"#00C896" },
              { range:"70-84",  label:"Good",      color:"#00C896" },
              { range:"50-69",  label:"Borderline",color:"#FFB830" },
              { range:"30-49",  label:"Weak",      color:"#FFB830" },
              { range:"0-29",   label:"Poor",      color:"#FF4D6D" },
            ].map((s,i) => (
              <div key={i} style={{ display:"flex", justifyContent:"space-between", fontSize:10 }}>
                <span style={{ color:"#4B5563" }}>{s.range}</span>
                <span style={{ color:s.color, fontWeight:600 }}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
